import React from 'react';
import './serviceheadertext.css';
import serviceContent from '../../../content/pages/service.json';

const ServiceHeaderText = () => {
    const { heading, text } = serviceContent.intro;

    return (
        <section className='service-header-text-container'>
            <h1>{heading}</h1>
            <p>
                {text.split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                        {i > 0 && <br />}
                        {line}
                    </React.Fragment>
                ))}
            </p>
        </section>
    );
};

export default ServiceHeaderText;
